import Vue from 'vue'
import 'bootstrap-table/dist/bootstrap-table.min.css'
import 'bootstrap-table/dist/bootstrap-table.js'
import BootstrapTable from 'bootstrap-table/dist/bootstrap-table-vue.esm.js'
import 'bootstrap-table/dist/extensions/export/bootstrap-table-export'
import 'tableexport.jquery.plugin/libs/FileSaver/FileSaver.min';
import 'tableexport.jquery.plugin/libs/js-xlsx/xlsx.core.min';
import 'tableexport.jquery.plugin';

Vue.component('BootstrapTable', BootstrapTable);
(<any>jQuery.fn).bootstrapTable.defaults.icons = {
    detailOpen: 'fa fa-plus',
    detailClose: 'fa fa-minus',
    refresh: 'fas fa-sync-alt',
    export: 'fas fa-table'
};
(<any>jQuery.fn).bootstrapTable.defaults.loadingFontSize = {
    loadingFontSize: `${12}px`,
}
